import { StorySaveRequestDto } from '../dto/request/story-save-request.dto';
import { StoryUpdateRequestDto } from '../dto/request/story-update-request.dto';
import { StoryResponseDto } from '../dto/response/story-response.dto';
import { BaseLandscapeService } from '../../base-landscape.service';

class StoryService extends BaseLandscapeService {
  public async fetchStories(): Promise<StoryResponseDto[]> {
    const response = await this.get<StoryResponseDto[]>(`/story`);
    return response.data;
  }

  public async fetchStoryById(id: string): Promise<StoryResponseDto> {
    const response = await this.get<StoryResponseDto>(`/story/${id}`);
    return response.data;
  }

  public async fetchStoriesByCompactId(
    compactId: string
  ): Promise<StoryResponseDto[]> {
    const response = await this.get<StoryResponseDto[]>(
      `/story/getbycompactid/${compactId}`
    );
    return response.data;
  }

  public async fetchStoriesByProjectId(
    projectId: string
  ): Promise<StoryResponseDto[]> {
    const response = await this.get<StoryResponseDto[]>(`/story/${projectId}`);
    return response.data;
  }

  public async saveStory(
    saveRequest: StorySaveRequestDto,
    type: string,
    id: string
  ): Promise<StoryResponseDto> {
    const response = await this.post<StoryResponseDto>(`/story`, saveRequest, {
      params: {
        type,
        id,
      },
    });
    return response.data;
  }

  public async updateStory(
    updateRequest: StoryUpdateRequestDto
  ): Promise<StoryResponseDto> {
    const response = await this.put<StoryResponseDto>(`/story`, updateRequest);
    return response.data;
  }

  public async deleteStory(
    existingId: string,
    compactId: string | null = null
  ): Promise<void> {
    await this.delete<void>(`/story/${existingId}`, {
      params: {
        compactId,
      },
    });
  }
}

const storyService = new StoryService();
export default storyService;
